export interface FixedPositionCruiseOfferId {
  id: string
  position: number
}

export function insertFixedPositionCruiseOfferIds(
  offerIds: Array<string>,
  fixedOfferIds: ReadonlyArray<FixedPositionCruiseOfferId>,
): Array<string> {
  const sortedFixedOfferIds = [...fixedOfferIds].sort((a, b) => a.position - b.position)

  const fixedIds = new Set(sortedFixedOfferIds.map(({ id }) => id))
  const positionedOfferIds = offerIds.filter(id => !fixedIds.has(id))

  sortedFixedOfferIds.forEach(({ id, position }) => {
    const positionIndex = Math.max(0, Math.floor(position) - 1)
    const targetIndex = Math.min(positionIndex, positionedOfferIds.length)

    positionedOfferIds.splice(targetIndex, 0, id)
  })

  return positionedOfferIds
}
